import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { ReactTable } from '../../types';

interface Props {
  cell: ReactTable.Cell;
}

const HoverableSpan: React.FC<Props> = ({ cell: { value } }) => {
  return (
    <OverlayTrigger
      trigger={['click', 'hover']}
      placement="bottom"
      overlay={
        <Tooltip id={value}>
          <div style={{ textAlign: 'left', color: '#fff' }}>{value}</div>
        </Tooltip>
      }
    >
      <span>{value}</span>
    </OverlayTrigger>
  );
};

export default HoverableSpan;
